/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bot: NonNullable<unknown> }} Leveling_Run_Subject_File_BotInputs */



/**
* | output |
* | --- |
* | "{bot}'s export" |
*
* @param {Leveling_Run_Subject_File_BotInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_run_subject_file_bot = /** @type {((inputs: Leveling_Run_Subject_File_BotInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Run_Subject_File_BotInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Экспорт ${i?.bot}`)
	return /** @type {LocalizedString} */ (`${i?.bot}'s export`)
});